export const TEXTS_PERSONAL = {
  es_ES: new Map([
    ['issues', 'incidencias'],
    ['chartNameEfectivos', 'TIPOS DE EMPLEADO PÚBLICO'],
    ['chartNameEfectivosPeq', 'TIPOS DE\nEMPLEADO PÚBLICO'],
    ['chartNamePersonal', 'PERSONAL POR ÁREA'],
    ['chartNameEfectivosPuesto', 'EFECTIVOS POR CLASIFICACIÓN PROFESIONAL'],
    ['chartNameEfectivosPuestoPeq', 'EFECTIVOS POR\nCLASIFICACIÓN\nPROFESIONAL'],
    ['titleEfectivosPuesto', 'EVOLUCIÓN EFECTIVOS'],
    ['titleEfectivosPuestoPeq', 'EVOLUCIÓN\nEFECTIVOS'],
    ['titleEfectivosPuestoVacantes', 'EVOLUCIÓN VACANTES'],
    ['titleEfectivosPuestoVacantesPeq', 'EVOLUCIÓN\nVACANTES'],
    ['chartPiramideLaboral', 'PIRÁMIDE LABORAL'],
    ['tasks', 'Cantidad'],
    ['last_update', 'Datos de '],
    ['current_year', 'Año en curso: '],
    ['01', 'Enero'],
    ['02', 'Febrero'],
    ['03', 'Marzo'],
    ['04', 'Abril'],
    ['05', 'Mayo'],
    ['06', 'Junio'],
    ['07', 'Julio'],
    ['08', 'Agosto'],
    ['09', 'Septiembre'],
    ['10', 'Octubre'],
    ['11', 'Noviembre'],
    ['12', 'Diciembre'],
    ['download', 'Descargar'],
    ['echartPMPServicioUnidadMedida', 'Días'],
    ['echartEvolucionVacntes', 'EVOLUCIÓN VACANTES'],
    ['personas', 'personas'],
  ]),
  ca_ES: new Map([
    ['issues', 'incidències'],
    ['download', 'Desar'],
    ['chartNameEfectivos', 'TIPUS D´EMPLEAT PÚBLIC'],
    ['chartNameEfectivosPeq', 'TIPUS\nD´EMPLEAT PÚBLIC'],
    ['chartNamePersonal', 'PERSONAL PER ÀREA'],
    ['chartNameEfectivosPuesto', 'EFECTIUS PER CLASSIFICACIÓ PROFESSIONAL'],
    ['chartNameEfectivosPuestoPeq', 'EFECTIUS PER\nCLASSIFICACIÓ\nPROFESSIONAL'],
    ['titleEfectivosPuesto', 'EVOLUCIÓ EFECTIUS'],
    ['titleEfectivosPuestoPeq', 'EVOLUCIÓ\nEFECTIUS'],
    ['titleEfectivosPuestoVacantes', 'EVOLUCIÓ VACANTS'],
    ['titleEfectivosPuestoVacantesPeq', 'EVOLUCIÓ\nVACANTS'],
    ['tasks', 'Quantitat'],
    ['last_update', 'Dades de '],
    ['current_year', 'Any en curs: '],
    ['chartPiramideLaboral', 'PIRÀMIDE LABORAL'],
    ['01', 'Gener'],
    ['02', 'Febrer'],
    ['03', 'Març'],
    ['04', 'Abril'],
    ['05', 'Maig'],
    ['06', 'Juny'],
    ['07', 'Juliol'],
    ['08', 'Agost'],
    ['09', 'Setembre'],
    ['10', 'Octubre'],
    ['11', 'Novembre'],
    ['12', 'Desembre'],
    ['download', 'Desar'],
    ['echartPMPServicioUnidadMedida', 'Dies'],
    ['echartEvolucionVacntes', 'EVOLUCIÓ VACANTS'],
    ['personas', 'persones'],
  ]),
};
